import { Component } from "react";
import { Alert, Checkbox, Col, message, PageHeader, Row, Select, Spin, Tabs, Tag, Upload } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import { TableItem, ButtonItem, SelectItem, SegmentedItem } from "../../../../Components/Items";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import {
  NOMBRE_HOJA,
  VACIO,
  COLUMNAS_NO_MAPEABLES,
  CAMPOS_SINCRONIZABLES,
  ETIQUETAS_BASE,
  ETIQUETAS_ESTADO_CIVIL,
  ETIQUETAS_AVISOS,
  construirIndiceEncabezados,
  mapearFilaExterna,
  compararConEmpleado,
  construirIndicesEmpleados,
  emparejarEmpleado,
  agruparAvisosCatalogo,
} from "../ImportarEmpleadosExterno/mapeoExterno";

const { TabPane } = Tabs;
const { Option } = Select;

const nombreCompleto = (e) =>
  [e.nombre, e.apellidoPaterno, e.apellidoMaterno].filter(Boolean).join(" ");

class EdicionMasivaEmpleadosExterno extends Component {
  state = {
    loading: false,
    empleados: [],
    catalogos: {
      tiposContrato: [], formasDePago: [], turnos: [], tiposPeriodo: [],
      tiposPrestacion: [], bancos: [], registrosPatronales: [], tiposRegimen: [],
      estados: [], departamentos: [], puestos: [], regimenFiscal: [], tiposJornada: [],
    },
    archivosExcel: [],
    // Se conservan las filas leídas para poder recalcular el diff cuando cambian
    // los valores generales, sin volver a subir el archivo.
    filasCrudas: [],
    // Campos que el layout externo no trae y se aplican a todos los empleados
    regimenFiscalId: undefined,
    tipoJornadaId: undefined,
    procesado: false,
    altas: [],
    ediciones: [],
    sinCambios: [],
    deshabilitados: [],
    filasConError: [],
    omitidos: [],
    avisosCatalogo: [],
    avisosPerdidos: 0,
    camposConCambios: [],
    camposSeleccionados: [],
    archivoError: null,
    archivoOmitidos: null,
    erroresBackend: [],
    pestana: "altas",
    // Qué se aplica al guardar: 'ambos' | 'soloAltas' | 'soloEditar'
    modoAplicar: "ambos",
  };

  componentDidMount() {
    this.consultarDatos();
  }

  consultarDatos() {
    this.setState({ loading: true });
    return axios
      .post(
        "empleados/datosParaEdicionMasivaExterna",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            empleados: res.data.empleados || [],
            catalogos: {
              tiposContrato: res.data.tiposContrato || [],
              formasDePago: res.data.formasDePago || [],
              turnos: res.data.turnos || [],
              tiposPeriodo: res.data.tiposPeriodo || [],
              tiposPrestacion: res.data.tiposPrestacion || [],
              bancos: res.data.bancos || [],
              registrosPatronales: res.data.registrosPatronales || [],
              tiposRegimen: res.data.tiposRegimen || [],
              estados: res.data.estados || [],
              departamentos: res.data.departamentos || [],
              puestos: res.data.puestos || [],
              regimenFiscal: res.data.regimenFiscal || [],
              tiposJornada: res.data.tiposJornada || [],
            },
          });
        } else {
          message.error("No se pudieron cargar los empleados de la empresa");
        }
        this.setState({ loading: false });
      });
  }

  atras() {
    this.props.history.goBack();
  }

  // Índices id → documento, para mostrar el nombre de cada catálogo en la vista previa.
  indicesCatalogos() {
    const { catalogos } = this.state;
    const indices = {};
    for (const nombre of Object.keys(catalogos)) {
      indices[nombre] = new Map(catalogos[nombre].map((x) => [String(x._id), x]));
    }
    return indices;
  }

  onChangeArchivo(e) {
    this.setState({ loading: true });
    if (e.file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      this.setState({ archivosExcel: [{ ...e.file, name: e.file.name, status: "uploading" }] });
      this.cargarArchivoExcel(e.file);
    } else {
      message.error("El archivo debe ser un archivo de Excel (.xlsx)");
      this.setState({ loading: false });
    }
  }

  cargarArchivoExcel(file) {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onloadend = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array", cellDates: true });
      const hoja = workbook.Sheets[NOMBRE_HOJA];
      if (!hoja) {
        message.error('No se encontró la hoja "' + NOMBRE_HOJA + '" en el archivo');
        this.setState({ loading: false, archivosExcel: [{ ...file, name: file.name, status: "error" }] });
        return;
      }
      const filas = XLSX.utils.sheet_to_row_object_array(hoja, { raw: false, dateNF: "YYYY-MM-DD" });
      const resultado = this.procesarFilas(filas);
      this.setState({
        ...resultado,
        archivosExcel: [{ ...file, name: file.name, status: "success" }],
        filasCrudas: filas,
        procesado: true,
        erroresBackend: [],
        loading: false,
        pestana: resultado.altas.length ? "altas" : "ediciones",
      });

      message.success(
        `${resultado.altas.length} alta(s) y ${resultado.ediciones.length} edición(es) con cambios`
      );
      if (resultado.omitidos.length) {
        message.warning(`${resultado.omitidos.length} empleado(s) se omitieron por estar de baja`);
      }
      if (resultado.filasConError.length) {
        message.error(`${resultado.filasConError.length} fila(s) con errores`);
      }
    };
  }

  // Al cambiar un valor general se recalcula el diff completo: ese campo pasa a
  // contar como cambio en todos los empleados cuyo valor actual sea distinto.
  cambiarValorGeneral(campo, valor) {
    this.setState({ [campo]: valor }, () => {
      if (!this.state.filasCrudas.length) return;
      this.setState(this.procesarFilas(this.state.filasCrudas));
    });
  }

  procesarFilas(filas) {
    const { empleados } = this.state;
    const indices = this.indicesCatalogos();
    const catalogos = this.state.catalogos;
    const indiceEncabezados = construirIndiceEncabezados(filas);
    const generales = {
      regimenFiscalId: this.state.regimenFiscalId,
      tipoJornadaId: this.state.tipoJornadaId,
    };

    // Emparejamiento en cascada: primero por RFC y, si no aparece, por nombre
    // completo. Se incluyen los deshabilitados para no duplicarlos.
    const indicesEmpleados = construirIndicesEmpleados(empleados);

    // Un empleado del sistema solo puede ser destino de una fila del archivo.
    const empleadosUsados = new Set();

    const altas = [];
    const ediciones = [];
    const sinCambios = [];
    const deshabilitados = [];
    const filasConError = [];
    const omitidos = [];
    const todosLosAvisos = [];
    const conteoPorCampo = new Map();
    const rfcVistos = new Set();
    let avisosPerdidos = 0;

    for (const fila of filas) {
      const r = mapearFilaExterna(fila, indiceEncabezados, catalogos, generales);

      if (r.omitirPorBaja) {
        omitidos.push(r.datosOmision);
        continue;
      }
      if (r.erroresFila.length) {
        filasConError.push({ Errores: r.erroresFila.join(", "), Fila: r.numFila, ...fila });
        continue;
      }

      const emp = r.emp;

      // Dos filas con el mismo RFC apuntarían al mismo empleado y la segunda
      // pisaría a la primera sin que se note. Se marca como error de datos.
      if (emp.rfc && rfcVistos.has(emp.rfc)) {
        filasConError.push({
          Errores: `RFC ${emp.rfc} repetido dentro del archivo`,
          Fila: r.numFila,
          ...fila,
        });
        continue;
      }
      if (emp.rfc) rfcVistos.add(emp.rfc);

      const errorDeFila = (mensaje) =>
        filasConError.push({ Errores: mensaje, Fila: r.numFila, ...fila });

      const { existente, criterio, error } = emparejarEmpleado(emp, indicesEmpleados, empleadosUsados);
      if (error) {
        errorDeFila(error);
        continue;
      }

      avisosPerdidos += r.avisosPerdidos;
      todosLosAvisos.push(...r.avisosCatalogo);

      if (!existente) {
        altas.push({
          clave: `fila-${r.numFila}`,
          emp,
          codigo: emp.numeroClave,
          rfc: emp.rfc,
          nombreCompleto: nombreCompleto(emp),
        });
        continue;
      }

      empleadosUsados.add(String(existente._id));

      if (existente.estado !== 1) {
        deshabilitados.push({
          clave: `fila-${r.numFila}`,
          codigo: emp.numeroClave,
          rfc: emp.rfc,
          nombreCompleto: nombreCompleto(emp),
          numero: existente.serieNumero || "",
          criterio,
        });
        continue;
      }

      // Diff campo por campo contra el empleado actual.
      const { cambios, detalle } = compararConEmpleado(emp, existente, indices);
      for (const clave of cambios) {
        conteoPorCampo.set(clave, (conteoPorCampo.get(clave) || 0) + 1);
      }

      const registro = {
        clave: `fila-${r.numFila}`,
        empleadoId: String(existente._id),
        emp,
        codigo: emp.numeroClave,
        rfc: emp.rfc,
        nombreCompleto: nombreCompleto(emp),
        numero: existente.serieNumero || "",
        criterio,
        cambios,
        detalle,
      };

      if (cambios.length) ediciones.push(registro);
      else sinCambios.push(registro);
    }

    const camposConCambios = CAMPOS_SINCRONIZABLES
      .filter((c) => conteoPorCampo.has(c.clave))
      .map((c) => ({ clave: c.clave, label: c.label, conteo: conteoPorCampo.get(c.clave) }));

    return {
      altas,
      ediciones,
      sinCambios,
      deshabilitados,
      filasConError,
      omitidos,
      avisosCatalogo: agruparAvisosCatalogo(todosLosAvisos),
      avisosPerdidos,
      camposConCambios,
      camposSeleccionados: camposConCambios.map((c) => c.clave),
      archivoError: filasConError.length ? this.construirLibro(filasConError, "Errores") : null,
      archivoOmitidos: omitidos.length ? this.construirLibro(omitidos, "Omitidos por Baja") : null,
    };
  }

  construirLibro(filas, nombreHoja) {
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(filas), nombreHoja);
    return wb;
  }

  descargarArchivo(workbook, nombreArchivo) {
    if (!workbook) return;
    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    const s2ab = (s) => {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    };
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = nombreArchivo;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  // Solo viajan los campos que el usuario dejó marcados y que de verdad cambiaron.
  edicionesParaEnviar() {
    const seleccionados = new Set(this.state.camposSeleccionados);
    const payload = [];
    for (const registro of this.state.ediciones) {
      const aplicables = registro.cambios.filter((c) => seleccionados.has(c));
      if (!aplicables.length) continue;
      const obj = { empleadoId: registro.empleadoId };
      for (const clave of aplicables) obj[clave] = registro.emp[clave];
      payload.push(obj);
    }
    return payload;
  }

  onFinish() {
    const { modoAplicar } = this.state;
    const aplicaAltas = modoAplicar !== "soloEditar";
    const aplicaEdiciones = modoAplicar !== "soloAltas";

    const altas = aplicaAltas ? this.state.altas.map((a) => a.emp) : [];
    const ediciones = aplicaEdiciones ? this.edicionesParaEnviar() : [];

    if (!altas.length && !ediciones.length) {
      message.warning("No hay nada que guardar con la opción seleccionada");
      return;
    }

    this.setState({ loading: true, erroresBackend: [] });
    axios
      .post(
        "empleados/sincronizarEmpleadosExterno",
        {
          empresaId: this.props.empresaId,
          columnas: aplicaEdiciones ? this.state.camposSeleccionados : [],
          altas,
          ediciones,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          message.error(res.data.message || "Hubo un error y no se guardaron los cambios");
          return;
        }
        message.success(
          `Se dieron de alta ${res.data.creados} y se actualizaron ${res.data.actualizados} empleado(s)`
        );
        if (res.data.repetidos) {
          message.warning(`${res.data.repetidos} alta(s) se omitieron por RFC repetido`);
        }
        if (res.data.lideresNoEncontrados) {
          message.warning(
            `No se encontró el líder de ${res.data.lideresNoEncontrados} empleado(s); asígnalo manualmente`
          );
        }
        const erroresBackend = res.data.errores || [];
        if (!erroresBackend.length) {
          this.atras();
          return;
        }
        // Se queda en la pantalla para mostrar las incidencias, pero la vista
        // previa ya no es válida: los datos del sistema cambiaron. Se recargan y
        // se limpia el archivo para que se vuelva a subir contra el estado nuevo.
        message.warning(`${erroresBackend.length} incidencia(s); revisa el detalle y vuelve a subir el archivo`);
        this.consultarDatos().then(() => {
          this.setState({
            erroresBackend,
            procesado: false,
            archivosExcel: [],
            altas: [],
            ediciones: [],
            sinCambios: [],
            deshabilitados: [],
            filasConError: [],
            omitidos: [],
            avisosCatalogo: [],
            avisosPerdidos: 0,
            camposConCambios: [],
            camposSeleccionados: [],
            archivoError: null,
            archivoOmitidos: null,
          });
        });
      });
  }

  columnasIdentificacion(conNumero) {
    const cols = [
      { title: "Código", dataIndex: "codigo", key: "codigo", width: 80, fixed: "left" },
      { title: "Nombre Completo", dataIndex: "nombreCompleto", key: "nombreCompleto", width: 220, fixed: "left" },
      { title: "RFC", dataIndex: "rfc", key: "rfc", width: 140 },
    ];
    if (conNumero) {
      cols.splice(1, 0, { title: "Núm.", dataIndex: "numero", key: "numero", width: 90 });
      cols.push({
        title: "Emparejado por",
        dataIndex: "criterio",
        key: "criterio",
        width: 130,
        render: (v) =>
          v === "Nombre" ? <Tag color="orange">Nombre</Tag> : <Tag>RFC</Tag>,
      });
    }
    return cols;
  }

  render() {
    const {
      loading, procesado, altas, ediciones, sinCambios, deshabilitados,
      filasConError, omitidos, avisosCatalogo, avisosPerdidos,
      camposConCambios, camposSeleccionados, erroresBackend, empleados, modoAplicar,
    } = this.state;

    const seleccionados = new Set(camposSeleccionados);
    const edicionesAplicables = ediciones.filter((e) =>
      e.cambios.some((c) => seleccionados.has(c))
    );

    const aplicaAltas = modoAplicar !== "soloEditar";
    const aplicaEdiciones = modoAplicar !== "soloAltas";
    const nAltas = aplicaAltas ? altas.length : 0;
    const nEdiciones = aplicaEdiciones ? edicionesAplicables.length : 0;
    const emparejadosPorNombre = [...ediciones, ...sinCambios].filter(
      (e) => e.criterio === "Nombre"
    ).length;

    // Solo se muestran columnas de campos marcados: la tabla refleja exactamente
    // lo que se va a guardar.
    const camposMostrados = CAMPOS_SINCRONIZABLES.filter((c) => seleccionados.has(c.clave));

    const columnasEdiciones = [
      ...this.columnasIdentificacion(true),
      ...camposMostrados.map((cfg) => ({
        title: cfg.label,
        key: cfg.clave,
        width: 210,
        render: (_, r) => {
          const d = r.detalle[cfg.clave];
          if (!d) return <span style={{ color: "#bfbfbf" }}>{VACIO}</span>;
          return (
            <span
              style={{
                backgroundColor: "#fff3cd",
                padding: "2px 6px",
                borderRadius: 4,
                display: "inline-block",
              }}
            >
              <span style={{ color: "#8c8c8c", textDecoration: "line-through" }}>{d.antes}</span>
              {"  →  "}
              <b>{d.despues}</b>
            </span>
          );
        },
      })),
    ];

    const columnasAltas = [
      ...this.columnasIdentificacion(false),
      { title: "Fecha Alta", key: "fechaAlta", width: 110,
        render: (_, r) => (r.emp.fechaAlta ? moment(r.emp.fechaAlta).format("DD/MM/YYYY") : VACIO) },
      { title: "Sexo", key: "sexo", width: 80, render: (_, r) => r.emp.sexo || VACIO },
      { title: "Salario Diario", key: "salarioDiario", width: 110,
        render: (_, r) => (r.emp.salarioDiario !== undefined ? `$${r.emp.salarioDiario}` : VACIO) },
      { title: "SBC Parte Fija", key: "sbcParteFija", width: 110,
        render: (_, r) => (r.emp.sbcParteFija !== undefined ? `$${r.emp.sbcParteFija}` : VACIO) },
      { title: "Saldo Ajuste Neto", key: "saldoAjusteNeto", width: 130,
        render: (_, r) => (r.emp.saldoAjusteNeto !== undefined ? `$${r.emp.saldoAjusteNeto}` : VACIO) },
      { title: "Base Pago", key: "basePago", width: 120,
        render: (_, r) => ETIQUETAS_BASE[r.emp.basePago] || VACIO },
      { title: "Base Cotización", key: "baseDeCotizacion", width: 130,
        render: (_, r) => ETIQUETAS_BASE[r.emp.baseDeCotizacion] || VACIO },
      { title: "Tipo Periodo", key: "tipoPeriodo", width: 120, render: (_, r) => r.emp.tipoPeriodo || VACIO },
      { title: "Turno", key: "turno", width: 110, render: (_, r) => r.emp.turno || VACIO },
      { title: "Registro Patronal", key: "regPat", width: 150,
        render: (_, r) => r.emp.registroPatronalIMSS || VACIO },
      { title: "Estado Civil", key: "estadoCivil", width: 110,
        render: (_, r) => ETIQUETAS_ESTADO_CIVIL[r.emp.estadoCivil] || VACIO },
      { title: "Avisos IMSS", key: "avisos", width: 160,
        render: (_, r) => ETIQUETAS_AVISOS[r.emp.avisosPendientes] || VACIO },
      { title: "Departamento", key: "departamento", width: 160, render: (_, r) => r.emp.departamento || VACIO },
      { title: "Puesto", key: "puesto", width: 160, render: (_, r) => r.emp.puesto || VACIO },
    ];

    const totalAAplicar = nAltas + nEdiciones;
    const textoBoton = !aplicaEdiciones
      ? `Dar de alta ${nAltas} empleado(s)`
      : !aplicaAltas
        ? `Editar ${nEdiciones} empleado(s)`
        : `Dar de alta ${nAltas} y editar ${nEdiciones} empleado(s)`;

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Edición Masiva de Empleados Desde Software Externo"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {this.state.archivoOmitidos && (
                <ButtonItem
                  style={{ marginRight: 8 }}
                  onClick={() => this.descargarArchivo(this.state.archivoOmitidos, "omitidos_por_baja_empleados.xlsx")}
                >
                  Descargar Omitidos por Baja
                </ButtonItem>
              )}
              {this.state.archivoError && (
                <ButtonItem
                  onClick={() => this.descargarArchivo(this.state.archivoError, "errores_edicion_masiva_externa.xlsx")}
                >
                  Descargar Errores
                </ButtonItem>
              )}
            </>
          }
        />
        <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5 }}>
          <Spin spinning={loading} tip="Cargando, espere por favor...">
            <Alert
              style={{ marginBottom: 16, marginTop: 10 }}
              type="info"
              showIcon
              message="Cómo funciona"
              description={
                <ol style={{ margin: 0, paddingLeft: 20 }}>
                  <li>
                    Sube el Excel que exporta el software de nómina externo, con su hoja{" "}
                    <b>{NOMBRE_HOJA}</b> y sus encabezados originales. No hay que reordenar
                    ni renombrar columnas.
                  </li>
                  <li>
                    Los empleados se emparejan primero por <b>RFC</b> y, si no aparece, por{" "}
                    <b>nombre y apellidos</b>. Los que no empaten con ninguno se dan de alta;
                    los que sí, se actualizan.
                  </li>
                  <li>
                    Cuando el emparejamiento fue por nombre, el <b>RFC del archivo sobreescribe
                    el del sistema</b> — es la forma de corregir un RFC mal capturado. Aparece
                    en la vista previa como cualquier otro cambio y lo puedes desmarcar.
                  </li>
                  <li>
                    Las filas con <b>Estatus empleado = B</b> (baja) se omiten por completo:
                    ni se dan de alta ni se editan.
                  </li>
                  <li>
                    Una <b>celda vacía no borra</b> el dato que ya está en el sistema; solo se
                    escribe lo que el archivo trae con valor.
                  </li>
                  <li>
                    Revisa la vista previa y desmarca los campos que no quieras aplicar antes
                    de guardar.
                  </li>
                </ol>
              }
            />

            <Row style={{ marginBottom: 16, alignItems: "center" }}>
              <Col span={12}>
                <Upload
                  showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
                  fileList={this.state.archivosExcel}
                  customRequest={this.onChangeArchivo.bind(this)}
                  accept=".xlsx"
                >
                  <ButtonItem type="primary" icon={<UploadOutlined />}>
                    Subir Excel del software externo
                  </ButtonItem>
                </Upload>
              </Col>
              <Col span={12} style={{ textAlign: "right", color: "#8c8c8c" }}>
                {empleados.length} empleado(s) en la empresa para comparar
              </Col>
            </Row>

            <div
              style={{
                border: "1px solid #f0f0f0",
                borderRadius: 4,
                padding: 12,
                marginBottom: 16,
              }}
            >
              <div style={{ marginBottom: 8 }}>
                <b>Valores iguales para todos</b>{" "}
                <span style={{ color: "#8c8c8c" }}>
                  — el archivo externo no trae estas dos columnas. Si las dejas vacías no se tocan.
                </span>
              </div>
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <SelectItem
                    placeholder="Régimen Fiscal"
                    allowClear
                    style={{ width: "100%" }}
                    value={this.state.regimenFiscalId}
                    onChange={(v) => this.cambiarValorGeneral("regimenFiscalId", v)}
                  >
                    {this.state.catalogos.regimenFiscal.map((r) => (
                      <Option key={r._id} value={r._id}>
                        {`${r.c_RegimenFiscal} - ${r.descripcion}`}
                      </Option>
                    ))}
                  </SelectItem>
                </Col>
                <Col xs={24} md={12}>
                  <SelectItem
                    placeholder="Tipo de Jornada"
                    allowClear
                    style={{ width: "100%" }}
                    value={this.state.tipoJornadaId}
                    onChange={(v) => this.cambiarValorGeneral("tipoJornadaId", v)}
                  >
                    {this.state.catalogos.tiposJornada.map((j) => (
                      <Option key={j._id} value={j._id}>
                        {`${j.c_TipoJornada} - ${j.Descripcion}`}
                      </Option>
                    ))}
                  </SelectItem>
                </Col>
              </Row>
            </div>

            {erroresBackend.length > 0 && (
              <Alert
                type="error"
                showIcon
                style={{ marginBottom: 12 }}
                message={`El servidor reportó ${erroresBackend.length} incidencia(s) al guardar`}
                description={
                  <ul style={{ margin: 0, paddingLeft: 20 }}>
                    {erroresBackend.map((e, i) => (
                      <li key={i}>
                        {(e.rfc || e.empleadoId) && <b>{e.rfc || e.empleadoId}: </b>}
                        {e.motivo}
                      </li>
                    ))}
                  </ul>
                }
              />
            )}

            {procesado && (
              <>
                <Alert
                  type={filasConError.length ? "warning" : "success"}
                  showIcon
                  style={{ marginBottom: 12 }}
                  message={
                    <>
                      <Tag color="green">{altas.length} altas nuevas</Tag>
                      <Tag color="gold">{edicionesAplicables.length} a editar</Tag>
                      {emparejadosPorNombre > 0 && (
                        <Tag color="orange">{emparejadosPorNombre} emparejados por nombre</Tag>
                      )}
                      <Tag>{sinCambios.length} sin cambios</Tag>
                      {deshabilitados.length > 0 && <Tag color="orange">{deshabilitados.length} deshabilitados</Tag>}
                      <Tag color="blue">{omitidos.length} omitidos por baja</Tag>
                      {filasConError.length > 0 && <Tag color="red">{filasConError.length} con error</Tag>}
                    </>
                  }
                />

                <Alert
                  type="info"
                  showIcon
                  style={{ marginBottom: 15 }}
                  message="Columnas del archivo externo sin equivalente en el sistema"
                  description={
                    "Estas columnas no se importan porque el sistema no tiene un campo para guardarlas: " +
                    COLUMNAS_NO_MAPEABLES.join(", ") + "."
                  }
                />

                {avisosCatalogo.length > 0 && (
                  <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: 15 }}
                    message="Valores que no existen en los catálogos de la empresa"
                    description={
                      <>
                        <div style={{ marginBottom: 6 }}>
                          Los empleados se guardan de todos modos, pero estos campos quedarán
                          vacíos. Da de alta estos valores en su catálogo y vuelve a subir el
                          archivo para que se llenen.
                        </div>
                        <ul style={{ margin: 0, paddingLeft: 20 }}>
                          {avisosCatalogo.map((g) => (
                            <li key={g.catalogo}>
                              <b>{g.catalogo}:</b>{" "}
                              {g.valores
                                .map((v) => `${v.valor} (${v.filas} empleado${v.filas !== 1 ? "s" : ""})`)
                                .join(", ")}
                            </li>
                          ))}
                        </ul>
                      </>
                    }
                  />
                )}

                {avisosPerdidos > 0 && (
                  <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: 15 }}
                    message={`${avisosPerdidos} empleado(s) tenían más de un aviso pendiente ante el IMSS marcado; solo se guardará el más relevante`}
                  />
                )}

                {deshabilitados.length > 0 && (
                  <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: 15 }}
                    message={`${deshabilitados.length} empleado(s) del archivo ya existen en el sistema pero están deshabilitados`}
                    description="No se dan de alta (sería un duplicado) ni se editan. Habilítalos desde el listado de empleados si quieres actualizarlos."
                  />
                )}

                {aplicaEdiciones && camposConCambios.length > 0 && (
                  <div
                    style={{
                      border: "1px solid #f0f0f0",
                      borderRadius: 4,
                      padding: 12,
                      marginBottom: 16,
                    }}
                  >
                    <div style={{ marginBottom: 8, display: "flex", justifyContent: "space-between" }}>
                      <b>Campos que se van a editar</b>
                      <span>
                        <ButtonItem
                          lessTime
                          style={{ marginRight: 8 }}
                          onClick={() =>
                            this.setState({ camposSeleccionados: camposConCambios.map((c) => c.clave) })
                          }
                        >
                          Marcar todos
                        </ButtonItem>
                        <ButtonItem lessTime onClick={() => this.setState({ camposSeleccionados: [] })}>
                          Desmarcar todos
                        </ButtonItem>
                      </span>
                    </div>
                    <Checkbox.Group
                      value={camposSeleccionados}
                      onChange={(v) => this.setState({ camposSeleccionados: v })}
                      style={{ width: "100%" }}
                    >
                      <Row>
                        {camposConCambios.map((c) => (
                          <Col xs={24} sm={12} md={8} lg={6} key={c.clave} style={{ marginBottom: 4 }}>
                            <Checkbox value={c.clave}>
                              {c.label}{" "}
                              <span style={{ color: "#8c8c8c" }}>
                                ({c.conteo} empleado{c.conteo !== 1 ? "s" : ""})
                              </span>
                            </Checkbox>
                          </Col>
                        ))}
                      </Row>
                    </Checkbox.Group>
                  </div>
                )}

                <div
                  style={{
                    marginBottom: 8,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 8,
                  }}
                >
                  <span>
                    <span style={{ marginRight: 8 }}>Qué se va a guardar:</span>
                    <SegmentedItem
                      value={modoAplicar}
                      onChange={(v) => this.setState({ modoAplicar: v })}
                      options={[
                        { label: `Ambos (${altas.length + edicionesAplicables.length})`, value: "ambos" },
                        { label: `Solo dar de alta (${altas.length})`, value: "soloAltas" },
                        { label: `Solo editar (${edicionesAplicables.length})`, value: "soloEditar" },
                      ]}
                    />
                  </span>
                  {totalAAplicar > 0 && (
                    <ButtonItem type="primary" onClick={this.onFinish.bind(this)}>
                      {textoBoton}
                    </ButtonItem>
                  )}
                </div>

                <Tabs
                  activeKey={this.state.pestana}
                  onChange={(k) => this.setState({ pestana: k })}
                >
                  <TabPane tab={`Altas (${altas.length})`} key="altas">
                    <TableItem
                      size="small"
                      dataSource={altas}
                      columns={columnasAltas}
                      rowKey="clave"
                      scroll={{ x: "max-content" }}
                    />
                  </TabPane>
                  <TabPane tab={`Ediciones (${edicionesAplicables.length})`} key="ediciones">
                    <TableItem
                      size="small"
                      dataSource={edicionesAplicables}
                      columns={columnasEdiciones}
                      rowKey="clave"
                      scroll={{ x: "max-content" }}
                    />
                  </TabPane>
                  <TabPane tab={`Sin cambios (${sinCambios.length})`} key="sinCambios">
                    <TableItem
                      size="small"
                      dataSource={sinCambios}
                      columns={this.columnasIdentificacion(true)}
                      rowKey="clave"
                      scroll={{ x: "max-content" }}
                    />
                  </TabPane>
                  <TabPane tab={`Deshabilitados (${deshabilitados.length})`} key="deshabilitados">
                    <TableItem
                      size="small"
                      dataSource={deshabilitados}
                      columns={this.columnasIdentificacion(true)}
                      rowKey="clave"
                      scroll={{ x: "max-content" }}
                    />
                  </TabPane>
                  <TabPane tab={`Omitidos por baja (${omitidos.length})`} key="omitidos">
                    <TableItem
                      size="small"
                      dataSource={omitidos.map((o, i) => ({ ...o, clave: `om-${i}` }))}
                      rowKey="clave"
                      scroll={{ x: "max-content" }}
                      columns={[
                        { title: "Código", dataIndex: "Código", key: "codigo", width: 80 },
                        { title: "Nombre", dataIndex: "Nombre", key: "nombre", width: 240 },
                        { title: "RFC", dataIndex: "RFC", key: "rfc", width: 140 },
                        { title: "Estatus", dataIndex: "Estatus", key: "estatus", width: 90 },
                        { title: "Fecha de baja", dataIndex: "Fecha de baja", key: "fechaBaja", width: 120 },
                        { title: "Causa", dataIndex: "Causa de la última baja", key: "causa", width: 200 },
                      ]}
                    />
                  </TabPane>
                  <TabPane tab={`Errores (${filasConError.length})`} key="errores">
                    <TableItem
                      size="small"
                      dataSource={filasConError.map((f, i) => ({ ...f, clave: `err-${i}` }))}
                      rowKey="clave"
                      scroll={{ x: "max-content" }}
                      columns={[
                        { title: "Fila", dataIndex: "Fila", key: "fila", width: 70 },
                        { title: "Errores", dataIndex: "Errores", key: "errores", width: 320 },
                        { title: "Código", dataIndex: "Código", key: "codigo", width: 80 },
                        { title: "Nombre", dataIndex: "Nombre", key: "nombre", width: 160 },
                        { title: "Apellido paterno", dataIndex: "Apellido paterno", key: "ap", width: 160 },
                        { title: "RFC", dataIndex: "RFC", key: "rfc", width: 140 },
                      ]}
                    />
                  </TabPane>
                </Tabs>
              </>
            )}
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EdicionMasivaEmpleadosExterno);
